import { ApiClient } from 'src/api/client'
import { COMPANY_MESSAGE_ROOM_PINS } from 'src/api/endpoints'

const ROOM_TYPE = {
  COMPANY_MESSAGE_ROOM: 0,
  COMPANY_MESSAGE_GROUP_ROOM: 1,
} as const

const roomType = (isGroup: boolean) => {
  return isGroup
    ? ROOM_TYPE.COMPANY_MESSAGE_GROUP_ROOM
    : ROOM_TYPE.COMPANY_MESSAGE_ROOM
}

export const createCompanyMessageRoomPinFetcher = async (
  company_message_room_id: number,
  isGroup: boolean,
) => {
  const res = await ApiClient.post(COMPANY_MESSAGE_ROOM_PINS, {
    company_message_room_id: company_message_room_id,
    room_type: roomType(isGroup),
  })
  if (res.error) return res
  return res.data
}

export const deleteCompanyMessageRoomPinFetcher = async (
  company_message_room_id: number,
  isGroup: boolean,
) => {
  const res = await ApiClient.delete(
    `${COMPANY_MESSAGE_ROOM_PINS}/${company_message_room_id}?room_type=${roomType(
      isGroup,
    )}`,
  )
  if (res.error) return res
  return res.data
}
